/**
 * @description验证身份证号
 * @param id
 * @return {boolean|boolean}
 */
import * as utils from '@/assets/js/utils'
import validate from "@/assets/js/validate";
import {validateLoginName} from '@/assets/js/api';

export default class Rules {
  constructor(formData, componentController) {
    this.formData = formData
    // 手机号过滤
    this.mobileNo = (rule, value, callback) => {
      if (!/^1[3-9]\d{9}$/.test(value) && value !== '') {
        callback(new Error('手机号格式不正确'));
      } else {
        callback()
      }
    };
    this.credentialNo = (rule, value, callback) => {
      if (this.formData.credentialType == "1") {
        if (!value) {
          callback();
        } else if (!utils.checkIDCard(value)) {
          callback(new Error("证件号码输入有误"));
        } else {
          callback();
        }
      } else {
        if (!value) {
          callback();
        } else if (String(value).length > 18) {
          callback(new Error("证件号码最大限制18位"));
        } else {
          callback();
        }
      }

    };

    this.userName = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入姓名'));
      } else {
        callback()
      }
    };
    // 目前只有在"用户信息添加"弹框里用了。这里就直接在这里判断了
    // 用户名
    this.loginName = async (rule, value, callback) => {
      // 调用接口查询当前用户名是否合规
      const checkResult = await this.validateLoginNameHandler(value);
      if (!value) {
        callback(new Error('请输入用户名'));
      } else if (!/^[A-Za-z0-9-]{6,32}$/.test(value)) {
        callback(new Error('用户名仅包含字母、数字、横线，长度6-32位'));
      } else if (!checkResult.flag) {
        callback(new Error(checkResult.msg));
      } else {
        callback();
      }
    };
    this.mediateSize = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入案件量'));
      } else if (!/^[1-9]\d*$/.test(value)) {
        callback(new Error('案件量只能是正整数'));
      } else {
        callback()
      }
    };
    this.repayTotalStage = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输分期期数'));
      } else if (!/^[1-9]\d*$/.test(value) || Number(value) < 1 || Number(value) > 120) {
        callback(new Error('分期期数为1~120的正整数'));
      } else {
        callback()
      }
    };
    this.repayEndFinishTime = (rule, value, callback) => {
      // 分期期数
      let repayTotalStage = this.formData.repayTotalStage
      // 每月还款日
      let repayPerTime = this.formData.repayPerTime
      // 首次还款日
      let startTime = new Date(this.formData.repayFirstFinishTime)
      let minTime = ''
      if (repayTotalStage == 1) {
        minTime = startTime
      } else {
        repayTotalStage = repayTotalStage - 2
        let time = utils.computedTime(repayTotalStage, repayPerTime, startTime) || startTime
        minTime = new Date(new Date(time).getTime() + 86400000)
      }

      if (!value) {
        callback(new Error('请选择最后一期还款截止日期'));
      } else if (new Date(minTime).getTime() > new Date(value).getTime()) {
        callback(new Error(`日期不能小于${utils.formatDate(minTime, 3)}`));
      } else {
        callback()
      }
    };
    // 第一期还款截止日期
    this.repayFirstFinishTime = (rule, value, callback) => {
      // 第一期还款日期
      const repayFirstFinishTime = this.formData.repayFirstFinishTime;
      // 先还日期
      const repayBeforeStageTime = this.formData.repayBeforeStageTime;
      if (!value) {
        callback(new Error('请选择第一期还款截止日期'));
      } else if (repayBeforeStageTime && new Date(repayBeforeStageTime).getTime() >= new Date(repayFirstFinishTime).getTime()) {
        callback(new Error('第一期还款截止日期需要晚于先还日期'));
      } else {
        callback()
      }
    }
    this.repayPerStageMoney = (rule, value, callback) => {
      callback()
    }
    this.repayStageTotalMoney = (rule, value, callback) => {
      callback()
    }

    this.repayTotalMoney = (rule, value, callback) => {
      let {repayType, money, totleMoney} = this.formData
      value = value.replace(/\,|\，/g, '')
      if (value === '') {
        callback(new Error('请输入还款金额'));
      } else if (!/^([+]?\d{0,12})(\.\d{1,2})?$/.test(value)) {
        callback(new Error('还款金额最大为12位整数且最多保留2位小数'));
        //  } else if ((repayType === '2' || repayType === '3')) {
      } else if (totleMoney) {
        //  let max = (Number(value) + money) / 100
        let max = (totleMoney / 100).toFixed(2)
        let now = Number(value).toFixed(2)
        if (Number(now) > Number(max)) {
          callback(new Error('单期还款金额不能大于还款总金额'));
        } else {
          callback()
        }
      } else {
        callback()
      }
    }

    this.repayBeforeStageMoney = (rule, value, callback) => {
      value = value.replace(/\,|\，/g, '')
      let repayTotalMoney = utils.re_money_format(this.formData.repayTotalMoney)
      let repayBeforeStageMoney = utils.re_money_format(this.formData.repayBeforeStageMoney)
      if (value === '') {
        callback(new Error('请输入分期前偿还金额'));
      } else if (!/^([+]?\d{0,12})(\.\d{1,2})?$/.test(value)) {
        callback(new Error('分期前偿还金额最大为12位整数且最多保留2位小数'));
      } else if (repayTotalMoney - repayBeforeStageMoney <= 0) {
        callback(new Error('分期前偿还金额不能大于等于还款金额'));
      } else {
        callback()
      }
    }
    this.commissionTerm = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入委案期限'));
      } else if (value > 120 || value < 1) {
        callback('委案期限为1~120个月')
      } else {
        callback()
      }
    }
    this.agtIdNumber = (rule, value, callback) => {
      if (value !== '' && value !== undefined && !utils.checkIDCard(value)) {
        callback(new Error("身份证号输入有误"));
      } else {
        callback()
      }
    }
    this.pltLeaderName = (rule, value, callback) => {
      let name = this.formData.type == '3' ? '主要负责人': '法定代表人'
      if (value === '') {
        callback(new Error(`${name}不能为空`));
      } else {
        callback()
      }
    }
    this.pltContactInfo = (rule, value, callback) => {
      if (value) {
        if (validate.telReg.test(value)) {
          callback()
        } else {
          callback('不满足手机号、固定电话规则')
        }
      } else {
        callback()
      }
    }
    this.dftPhone2 = (rule, value, callback) => {
      if (!validate.telReg.test(value) && value !== '' && value !== undefined) {
        callback('不满足手机号、固定电话规则')
      } else {
        callback()
      }
    }
    this.telephone = (rule, value, callback) => {
      if (!/(^((\d{3,4}[-－])|(\(\d{3,4}\))|(\（\d{3,4}\）))\d{7,8}$)/.test(value) && value !== '' && value !== undefined) {
        callback('不满足固定电话规则')
      } else {
        callback()
      }
    }
    //邮箱过滤
    this.cEmail = (rule, value, callback) => {
      if (!validate.emailReg.test(value) && value !== '' && value !== undefined) {
        callback(new Error("邮箱格式不正确"));
      } else {
        callback();
      }

    };

    this.caseReason = (rule, value, callback) => {
      let require = this.formData.caseReasonPid === '9178'
      if (!value && require) {
        callback(new Error('请选择业务类型'));
      } else {
        callback();
      }
    };

    this.rules = {
      actParentUnit: [
        {required: true, message: '上级机构不能为空', trigger: 'blur'}
      ],
      actUnit: [
        {required: true, message: '机构名称不能为空', trigger: 'blur'}
      ],
      actDiviMode: [
        {required: true, message: '分案模式不能为空', trigger: 'blur'}
      ],
      actFieldExtDto: {
        actDiviMode: [
          {required: true, message: '分案模式不能为空', trigger: 'blur'}
        ],
        openCauseType: [
          {required: true, message: '开通案由不能为空', trigger: 'change'}
        ],
      },
      roleList: [
        {required: true, message: '请选择角色', trigger: 'change'}
      ],
      userValid: [
        {required: true, message: '启用状态不能为空', trigger: 'blur'}
      ],
      actOutCallFlag: [
        {required: true, message: '请选择是否开通外呼功能', trigger: 'change'}
      ],
      dxjsr: [
        {required: false, message: '请选择短信接收人', trigger: 'change'}
      ],
      dxmb: [
        {required: false, message: '请填写短信模板', trigger: 'blur'}
      ],
      ahscgz: [
        {required: false, message: '请填写案号生成规则', trigger: 'blur'}
      ],
      loginName: [
        {required: true, validator: this.loginName, trigger: 'blur'}
      ],
      userName: [
        {required: true, validator: this.userName, trigger: 'blur'}
      ],
      mobileNo: [
        {required: false, message: '请输入手机号', trigger: 'blur'},
        {pattern: validate.phoneReg, message: '手机号格式不正确'}
      ],
      credentialType: [
        {required: false, message: '请选择证件类型', trigger: 'change'}
      ],
      credentialNo: [
        {required: false, validator: this.credentialNo, trigger: 'blur'}
      ],
      ssjg: [
        {required: true, message: '请选择所属机构', trigger: 'change'}
      ],
      actOutCallStartTime: [
        {required: true, message: '请选择开始日期', trigger: 'change'}
      ],
      actOutCallEndTime: [
        {required: true, message: '请选择结束日期', trigger: 'change'}
      ],
      mediateSize: [
        {required: true, validator: this.mediateSize, trigger: 'blur'}
      ],
      acceptResult: [
        {required: true, message: '请选择受理结果', trigger: 'change'}
      ],
      orgId: [
        {required: true, message: '请选择机构', trigger: 'change'}
      ],
      userId: [
        {required: true, message: '请选择调解员', trigger: 'change'}
      ],
      prePlanType: [
        {required: true, message: '请选择方案类型', trigger: 'change'}
      ],
      description: [
        {required: true, message: '请输入方案说明', trigger: 'blur'}
      ],
      periodsNumber: [
        {required: true, message: '请选择分期期数设置', trigger: 'change'}
      ],
      repaymentDeadline: [
        {required: true, message: '请选择还款日期设置', trigger: 'change'}
      ],
      smsTempId: [
        {required: true, message: '请选择短信模板', trigger: 'change'}
      ],
      smsContent: [
        {required: true, message: '请输入模板内容', trigger: 'blur'},
        {max: 500, message: '短信模板最多500字', trigger: 'change'}
      ],
      stName: [
        {required: true, message: '请填写短信模板名称', trigger: 'blur'}
      ],
      stReceiverList: [
        {required: true, message: '请选择短信接收人', trigger: 'change'}
      ],
      stGeneralType: [
        {required: true, message: '请选择模板类型', trigger: 'change'}
      ],
      detailType: [
        {required: true, message: '请选择短信接收方', trigger: 'change'}
      ],
      repayType: [
        {required: true, message: '请选择还款方式', trigger: 'change'}
      ],
      repayTotalMoney: [
        {required: true, validator: this.repayTotalMoney, trigger: 'blur'}
      ],
      repayFinishTime: [
        {required: true, message: '请选择还款截止日期', trigger: 'blur'}
      ],
      repayTotalStage: [
        {required: true, validator: this.repayTotalStage, trigger: 'blur'}
      ],
      repayPerTime: [
        {required: true, message: '请选择每期还款日期', trigger: 'change'}
      ],
      repayFirstFinishTime: [
        {required: true, validator: this.repayFirstFinishTime, trigger: 'change'}
      ],
      repayEndFinishTime: [
        {required: true, validator: this.repayEndFinishTime, trigger: 'blur'}
      ],

      repayBeforeStageMoney: [
        {required: true, validator: this.repayBeforeStageMoney, trigger: 'blur'}
      ],
      repayBeforeStageTime: [
        {required: true, message: '请选择先还日期', trigger: 'change'}
      ],
      repayStageTotalMoney: [
        {required: true, validator: this.repayStageTotalMoney, trigger: 'blur'}
      ],
      repayPerStageMoney: [
        {required: true, validator: this.repayPerStageMoney, trigger: 'blur'}
      ],
      repayRemark: [
        {required: true, message: '请输入备注说明', trigger: 'blur'}
      ],
      pltId: [
        {required: true, message: '请选择申请人模板', trigger: 'change'}
      ],
      pass: [
        {required: true, message: '请选择审核结果', trigger: 'change'}
      ],
      reason: [
        {required: true, message: '请选择不通过原因', trigger: 'change'}
      ],
      content: [
        {required: false, message: '请输入原因说明', trigger: 'change'}
      ],
      batchName: [
        {required: true, message: '请输入批次号', trigger: 'change'}
      ],
      commissionOrgan: [
        {required: true, message: '请输入委案机构', trigger: 'change'}
      ],
      commissionDate: [
        {required: true, message: '请选择委案日期', trigger: 'change'}
      ],
      commissionTerm: [
        {required: true, validator: this.commissionTerm, trigger: 'blur'}
      ],
      caseReasonPid: [
        {required: true, message: '请选择纠纷类型', trigger: 'change'}
      ],
      caseReason: [
        {validator: this.caseReason, trigger: 'change'}
      ],
      pltUnit: [
        {required: true, message: '请输入单位名称'}
      ],
      preCaseNo: [
        {required: false, message: '请输入预字案号', trigger: 'blur'}
      ],
      pltLicenceType: [
        {required: true, message: '请选择证照类型', trigger: 'change'}
      ],
      pltLicenceNumber: [
        {required: true, message: '请输入证照号码', trigger: 'blur'}
      ],
      pltContactInfo: [
        {required: false, message: '请输入联系电话', trigger: 'blur'},
        {pattern: validate.telReg, message: '联系电话格式不正确'}
      ],
      // pltLeaderName: [
      //   {required: true, message: '请输入法定代表人', trigger: 'blur'}
      // ],
      pltLeaderName: [
        {required: true, validator: this.pltLeaderName, trigger: 'blur'}
      ],
      pltAddress: [
        {required: false, message: '请输入单位地址', trigger: 'blur'},
      ],


      pltLeaderJob: [
        {required: false, message: '请输入法定代表人职务', trigger: 'blur'},
      ],
      agtName: [
        {required: true, message: '请输入姓名', trigger: 'blur'}
      ],
      agtPermission: [
        {required: true, message: '请选择代理权限', trigger: 'change'}
      ],
      pltLeaderIdNumber: [
        {required: false, message: '请输入法定代表人身份证号', trigger: 'blur'},
        {validator: this.agtIdNumber, trigger: 'blur'},
      ],
      agtIdNumber: [
        {required: true, message: '请输入身份证号', trigger: 'blur'},
        {validator: this.agtIdNumber, trigger: 'blur'},
      ],
      dftIdNumber1: [
        {required: false, message: '请输入身份证号', trigger: 'blur'},
        {validator: this.agtIdNumber, trigger: 'blur'}
      ],
      dftIdNumber2: [
        {required: false, message: '请输入身份证号', trigger: 'blur'},
        {validator: this.agtIdNumber, trigger: 'blur'}
      ],
      // 身份证号
      idNumber: [
        {required: true, message: '请输入身份证号', trigger: 'blur'},
        {validator: this.agtIdNumber, trigger: 'blur'},
      ],
      idNo: [
        {required: false, message: '请输入身份证号', trigger: 'blur'},
        {validator: this.agtIdNumber, trigger: 'blur'},
      ],
      idType: [
        {required: true, message: '请输入证件类型'}
      ],
      agtType: [
        {required: true, message: '请输入代理人类型'}
      ],
      agtLicnumber: [
        {required: true, message: '请输入执业证号', trigger: 'blur'}
      ],
      dftName1: [
        {required: true, message: '请输入姓名', trigger: 'blur'}
      ],
      agtPhone: [
        {required: true, message: '请输入手机号码', trigger: 'blur'},
        {validator: this.mobileNo, trigger: 'blur'},
      ],
      otherPhone: [
        {validator: this.mobileNo, trigger: 'blur'},
      ],
      agtUnitContactInfo: [
        {required: false, message: '请输入单位电话', trigger: 'blur'},
        {validator: this.dftPhone2, trigger: 'blur'},
      ],
      dftPhone1: [
        {required: true, message: '请输入手机号', trigger: 'blur'},
        {validator: this.mobileNo, trigger: 'blur'},
      ],
      dftName2: [
        {required: true, message: '请输入姓名', trigger: 'blur'}
      ],
      pltLeaderPhone: [
        {required: false, message: '请输入法定代表人手机号码', trigger: 'blur'},
        {validator: this.mobileNo, trigger: 'blur'},
      ],
      dftPhone2: [
        {required: true, message: '请输入手机号', trigger: 'blur'},
        {validator: this.dftPhone2, trigger: 'blur'},
      ],
      dftOranLeglePhone: [
        {required: true, message: '请输入法定代表人联系电话', trigger: 'blur'},
        {validator: this.dftPhone2, trigger: 'blur'},
      ],
      dftEmail: [
        {required: false, message: '请输入邮箱', trigger: 'blur'},
        {validator: this.cEmail, trigger: 'blur'}
      ],
      email: [
        {required: false, message: '请输入邮箱', trigger: 'blur'},
        {validator: this.cEmail, trigger: 'blur'}
      ],
      dftOranAddress: [
        {required: false, message: '请输入单位地址', trigger: 'blur'},
      ],
      dftDeliveryAddress: [
        {required: false, message: '请输入送达地址', trigger: 'blur'},
      ],
      dftCurAddress: [
        {required: false, message: '请输入现住址', trigger: 'blur'},
      ],
      dftPerAddress: [
        {required: false, message: '请输入户籍地址', trigger: 'blur'},
      ],
      dftBirthday: [
        {required: false, message: '请选择出生日期', trigger: 'change'},
      ],
      dftSex: [
        {required: false, message: '请选择性别', trigger: 'change'},
      ],
      dftNation: [
        {required: false, message: '请选择民族', trigger: 'change'},
      ],
      dftOranName: [
        {required: true, message: '请输入单位名称', trigger: 'blur'}
      ],
      dftOranIdType: [
        {required: true, message: '请选择证照类型', trigger: 'change'}
      ],
      dftOranIdNumber: [
        {required: true, message: '请输入证照号码', trigger: 'blur'}
      ],
      dftOranLegleName: [
        {required: true, message: '请输入法定代表人', trigger: 'blur'}
      ],
      dftPost: [
        {required: false, message: '请输入法定代表人职务', trigger: 'blur'}
      ],
      agtMail: [
        {required: false, message: '请输入电子送达邮箱', trigger: 'blur'},
        {pattern: validate.emailReg, message: '电子送达邮箱格式不正确'}
      ],
      agtDeliveryAddress: [
        {required: false, message: '请输入送达地址', trigger: 'blur'},
      ],
      agtLawyerType: [
        {required: false, message: '请选择律师执业类别', trigger: 'change'},
      ],
      agtOffice: [
        {required: false, message: '请输入所在律所', trigger: 'blur'},
      ],
      lawRegistrAddress: [
        {required: false, message: '请输入律所注册地', trigger: 'blur'},
      ],
      // 姓名
      personName: [
        {required: true, message: '请输入姓名'}
      ],
      // 手动添加案件 - 案件批次
      caseBatchId: [
        {required: true, message: '请选择案件批次'}
      ],
      reqAmount: [
        {required: false, message: '请输入请求标的额', trigger: 'blur'}
      ],
      claims: [
        {required: false, message: '请输入申请请求', trigger: 'blur'}
      ],
      deliveryAddress: [
        {required: false, message: '请输入送达地址', trigger: 'blur'}
      ],
      currentAddress: [
        {required: false, message: '请输入现住址', trigger: 'blur'}
      ],
      domicileAddress: [
        {required: false, message: '请输入户籍地址', trigger: 'blur'}
      ],
      birthday: [
        {required: false, message: '请选择出生日期', trigger: 'change'}
      ],
      sex: [
        {required: false, message: '请选择性别', trigger: 'change'}
      ],
      age: [
        {required: false, message: '请输入年龄', trigger: 'blur'}
      ],
      nation: [
        {required: false, message: '请选择民族', trigger: 'change'}
      ],
      contractNo: [{required: false, message: '请输入合约编号', trigger: 'blur'}],
      iOUNumber: [{required: false, message: '请输入借据号', trigger: 'blur'}],
      contractName: [{required: false, message: '请输入合约名称', trigger: 'blur'}],
      account: [{required: false, message: '请输入账号', trigger: 'blur'}],
      cardType: [{required: false, message: '请选择信用卡类型', trigger: 'change'}],
      cardNo: [{required: false, message: '请输入卡号', trigger: 'blur'}],
      applyTime: [{required: false, message: '请选择申领时间', trigger: 'change'}],
      creditCardLimit: [{required: false, message: '请输入信用卡额度', trigger: 'blur'}],
      totalAmount: [{required: false, message: '请输入欠款总金额', trigger: 'blur'}],
      arrearsCalcEndTime: [{required: false, message: '请选择欠款计算截止日期', trigger: 'change'}],
      interestCalcStartTime: [{required: false, message: '请选择利息起算日期', trigger: 'change'}],
      overdueTime: [{required: false, message: '请选择逾期开始日期', trigger: 'change'}],
      principal: [{required: false, message: '请输入尚欠本金', trigger: 'blur'}],
      interest: [{required: false, message: '请输入尚欠利息', trigger: 'blur'}],
      liquidatedDamages: [{required: false, message: '请输入尚欠违约金/滞纳金', trigger: 'blur'}],
      annualFee: [{required: false, message: '请输入尚欠年费', trigger: 'blur'}],
      transactionFee: [{required: false, message: '请输入尚欠交易手续费', trigger: 'blur'}],
      commissions: [{required: false, message: '请输入尚欠分期付款手续费', trigger: 'blur'}],
      otherFee: [{required: false, message: '请输入尚欠其他费用', trigger: 'blur'}],

      totalLoanAmount: [{required: false, message: '请输入借款总金额', trigger: 'blur'}],
      loanDate: [{required: false, message: '请选择放款日期', trigger: 'change'}],
      numberOfLoanPeriods: [{required: false, message: '请输入借款期数', trigger: 'blur'}],
      payableEveryPeriod: [{required: false, message: '请输入每期应还金额（本+利）', trigger: 'blur'}],
      numberOfRepayments: [{required: false, message: '请输入已还期数', trigger: 'blur'}],
      totalPaid: [{required: false, message: '请输入已还总金额', trigger: 'blur'}],
      remainingPrincipal: [{required: false, message: '请输入剩余本金', trigger: 'blur'}],
      totalOverdueAmount: [{required: false, message: '请输入逾期总金额', trigger: 'blur'}],
      lateStartDate: [{required: false, message: '请选择逾期开始日期', trigger: 'change'}],
      overdueNumber: [{required: false, message: '请输入逾期期数', trigger: 'blur'}],
      penaltyInterestDeadline: [{required: false, message: '请选择罚息截止日期', trigger: 'change'}],
      penaltyInterestAmount: [{required: false, message: '请输入罚息金额', trigger: 'blur'}],
      productName: [{required: false, message: '请输入产品名称', trigger: 'blur'}],
      creditDate: [{required: false, message: '请选择授信日期', trigger: 'change'}],
      creditValidPeriod: [{required: false, message: '请选择授信有效期', trigger: 'change'}],
      lineOfCredit: [{required: false, message: '请输入授信额度', trigger: 'blur'}],
      withdrawalDate: [{required: false, message: '请选择提现日期', trigger: 'change'}],
      expiryDate: [{required: false, message: '请选择到期日期', trigger: 'change'}],
      withdrawalAmount: [{required: false, message: '请输入提现金额', trigger: 'blur'}],
      loanPeriod: [{required: false, message: '请输入借款期限', trigger: 'blur'}],
      execRate: [{required: false, message: '请输入执行利率', trigger: 'blur'}],
      penaltyInterestRate: [{required: false, message: '请输入罚息利率', trigger: 'blur'}],
      useOfTheLoan: [{required: false, message: '请输入借款用途', trigger: 'blur'}],
      repaymentType: [{required: false, message: '请输入还款方式', trigger: 'blur'}],
      bankCardNo: [{required: false, message: '请输入银行卡号', trigger: 'blur'}],
      noLongerRepaymentDate: [{required: false, message: '请选择不再还款日期', trigger: 'blur'}],
      penaltyInterestCalcStartDate: [{required: false, message: '请选择罚息计算起始日期', trigger: 'blur'}],
      penaltyInterestCalcDeadline: [{required: false, message: '请选择罚息计算截止日期', trigger: 'blur'}],
      overdueDays: [{required: false, message: '请输入逾期天数', trigger: 'blur'}],
      principalPaid: [{required: false, message: '请输入已还本金', trigger: 'blur'}],
      interestPaid: [{required: false, message: '请输入已还利息', trigger: 'blur'}],
      penaltyInterestPaid: [{required: false, message: '请输入已还罚息', trigger: 'blur'}],
      unpaidPrincipal: [{required: false, message: '请输入未还本金', trigger: 'blur'}],
      unpaidInterestFee: [{required: false, message: '请输入未还息费', trigger: 'blur'}],
      compoundInterest: [{required: false, message: '请输入复利', trigger: 'blur'}],
      caseNumContent: [{required: true, message: '请输入案号生成规则', trigger: 'blur'}],
      // 案件分类
      caseType: [{required: true, message: '请选择案件分类'}],
      // 诉讼类型
      litigationType: [{required: true, message: '请选择诉讼类型'}],
      // 经办法院
      courtName: [{required: true, message: '请输入经办法院'}],
      // 经办人
      manager: [{required: true, message: '请输入经办人'}],
      // 案号
      caseNo: [{required: true, message: '请输入案号'}],
      // 结案时间
      finishCaseTime: [{required: true, message: '请选择结案时间'}],
      // 结案方式
      finishCaseType: [{required: true, message: '请选择结案方式'}],
      // 驳回申请事由
      rejectionApplyReason: [{required: true, message: '请选择驳回申请事由'}],
      // 应缴调解费
      payableAmount: [{required: true, message: '请输入应缴调解费'}],
      // 实际缴费
      actualPayment: [{required: true, message: '请输入实际缴费'}],
      unitName: [{required: true, message: '请输入单位名称'}],
      pltPerAddress: [{required: true, message: '请输入户籍地址'}],
      pltDeliveryAddress: [{required: true, message: '请输入送达地址'}],
      permanentAddress: [{required: true, message: '请输入经常居住地'}],
      isAppointDelivery: [{required: true, message: '请选择合同是否约定电子送达'}],
      pltEnterpriseType: [{required: true, message: '请选择单位性质'}],
      country: [{required: true, message: '请选择国籍'}],
      pltLeaderTelephone: [
        {required: true, message: '请输入固定电话'},
        {validator: this.telephone, trigger: 'blur'}
      ],
      profession: [{required: true, message: '请选择职业'}],
      pltLeaderIdType: [{required: true, message: '请选择证件类型'}],
      signTime: [{required: true, message: '请选择调解协议签订日期'}],
      agentSex: [{required: true, message: '请选择性别'}],
      agtIdType: [{required: true, message: '请选择证件类型'}],
      address: {
        adsName: [{required: true, message: '请输入姓名'}],
        adsPhone: [
          {required: true, message: '请输入手机号码'},
          {validator: this.mobileNo, trigger: 'blur'},
        ],
        adsAddress: [{required: true, message: '请输入送达地址'}],
        adsContact: [{required: true, message: '请输入其他联系方式'}],
        email: [
          {required: true, message: '请输入邮箱'},
          {validator: this.cEmail, trigger: 'blur'}
        ],
        curAddress: [{required: true, message: '请输入现住址'}],
      },
      // 个人中心-回访电话
      phoneNo: [
        {required: false, validator: this.dftPhone2}
      ],
      // 有效截止时间
      selfSignExpired: [
        {required: true, message: '请选择有效截止日期'}
      ],
      // 签章规则配置 - start
      // 管理人姓名
      auditUserName: [
        {required: true, message: '请输入管理人姓名'}
      ],
      // 管理人手机号
      auditMobileNo: [
        {required: true, message: '请输入管理人手机号'},
        {validator: this.mobileNo, trigger: 'blur'},
      ],
      // 管理人身份证号
      auditCredentialNo: [
        {required: true, message: '请输入管理人身份证号'},
        {validator: this.agtIdNumber, trigger: 'blur'},
      ],
      // 签章规则配置 - end
      phone: [
        {required: true, message: '请输入手机号'},
        {validator: this.mobileNo, trigger: 'blur'},
      ],
      mdActId: [{required: true, message: '请选择调解中心'}],
      chooseFulfillmentStatus: [
        {required: true, message: '请选择履约登记'},
      ],
      finishStatus: [{required: true, message: '请选择办结结果'}],
      sucessType: [{required: true, message: '请选择调解成功方式'}],
      followUpProceType: [{required: true, message: '请选择后续处置'}],
      failType: [{required: true, message: '请选择失败原因'}],
      applicantIdentity: [{required: true, message: '请选择申请人身份'}],
      bseApplicationPersonType: [{required: true, message: '请选择申请人类型'}],
      bseQfkjzrq: [
        {required: true, message: '请输入申请标的额'}
      ]
    }

    if (componentController) {
      Object.keys(componentController).forEach(key => {
        let rule = this.rules[key]
        if (rule) {
          if (rule instanceof Array) {
            rule[0].required = componentController[key].required
          } else {
            Object.keys(rule).forEach(childrenKey => {
              let childrenRule = rule[childrenKey]
              if (childrenRule && componentController[key][childrenKey]) {
                childrenRule[0].required = componentController[key][childrenKey].required
              }
            })
          }
        }
      })
    }
  }
  // 校验用户名是否合法
  validateLoginNameHandler(loginName) {
    return new Promise((resolve, reject) => {
      if (!loginName) {
        resolve({flag: true});
      }
      validateLoginName({loginName}).then(res => {
        if (res.code && res.code.toString() === '200') {
          resolve({flag: true});
        } else {
          resolve({flag: false, msg: res.msg});
        }
      }).catch(err => {
        reject(false);
      })
    })
  }

  isObject(obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
  }

  /**
   * @description 批量更新规则
   * @param {Object} rules
   */
  updateRules(rules) {
    if (!this.isObject(rules)) {
      return new Error('updateRules - 参数不正确');
    }
    Object
      .keys(rules)
      .forEach(key => {
        this.updateRule(key, rules[key]);
      });
  }

  /**
   * @description 更新规则
   * @param {string} key
   * @param {Array} rules
   */
  updateRule(key, rules) {
    if (!Array.isArray(rules)) {
      return new Error('updateRule - 参数不正确');
    }

    const targetRules = this.rules[key];
    if (targetRules) {
      for (let index = 0; index < rules.length; index++) {
        Object.assign(targetRules[index], rules[index]);
      }
    } else {
      this.rules[key] = rules.slice();
    }
  }

  /**
   * @description 批量删除规则
   * @param {array} keys
   */
  delRules(keys) {
    keys.forEach(key => {
      this.delRule(key);
    });
  }

  /**
   * @description 删除规则
   * @param {string} key
   */
  delRule(key) {
    if (this.rules[key]) {
      delete this.rules[key];
    }
  }
}
